/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartTrendXyUpIcon16Regular = forwardRef('DataChartTrendXyUpIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.75 1.75a.75.75 0 0 0-1.5 0V12.5a2.25 2.25 0 0 0 2.25 2.25h11.75a.75.75 0 0 0 0-1.5H2.5a.75.75 0 0 1-.75-.75V1.75Z" }),
        React.createElement("path", { d: "M14.53 4.53a.75.75 0 0 0-1.06-1.06L9.5 7.44 7.742 5.681a1.05 1.05 0 0 0-1.484 0L3.47 8.47a.75.75 0 0 0 1.06 1.06L7 7.06l1.758 1.758c.41.41 1.074.41 1.485 0L14.53 4.53Z" })));
});
